import api from "../api/flexapi";

export const FETCH_MENTAL_WELLNESS_BEGIN = "FETCH_MENTAL_WELLNESS_BEGIN";
export const FETCH_MENTAL_WELLNESS_SUCCESS = "FETCH_MENTAL_WELLNESS_SUCCESS";
export const FETCH_MENTAL_WELLNESS_FAILED = "FETCH_LAUNCHPAD_LOAD_FAILED";

// Call API to load module data
export default () => {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: FETCH_MENTAL_WELLNESS_BEGIN, payload: null });

    api
      .getMentalWellness()
      .then(response => {
        dispatch({ type: FETCH_MENTAL_WELLNESS_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: FETCH_MENTAL_WELLNESS_FAILED,
          payload: err.response ? err.response.body : err,
        });
      });
  };
};




// WEBPACK FOOTER //
// ./actions/mentalWellnessActions.js